module.exports = __webpack_public_path__ + "img/t-8.0445cdb4.jpg";